import { Outlet } from 'react-router-dom';

export default function MiniLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
